import tracker from './BrowserActivityTracker';

export const useBrowserActivityTracker = () => tracker;
